import * as React from 'react';
import { Link } from 'react-router-dom';
import cls from 'classnames';

import Routes from '../../services/Routes';

import { SearchBar } from './compositions/SearchBar';
import image from './img/goldbelly@2x.png';

import styles from './index.module.sass';

export const Header = () => {
  const [searchFocus, setSearchFocus] = React.useState<boolean>(false);

  return (
    <header className={styles.header} role="search">
      <nav
        className={cls(
          styles.nav,
          'navbar navbar-expand-md navbar-dark position-fixed w-100 shadow-sm bg-primary'
        )}
      >
        <div className="container-xl">
          <Link className="navbar-brand d-flex align-items-center" to={Routes.home()}>
            <img alt="Lit" className={cls(styles.image, 'mr-2')} src={image} />
            <strong className="fs-7">Lit</strong>
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarCollapse">
            <form
              className={cls(styles.form, 'ml-auto', {
                [styles.formFocused]: searchFocus,
              })}
            >
              <SearchBar
                className={cls('form-control border-0', styles.search)}
                onBlur={() => setSearchFocus(false)}
                onFocus={() => setSearchFocus(true)}
              />
            </form>
          </div>
        </div>
      </nav>
    </header>
  );
};
